export function parseAttendeeBadgeScan(scanText) {
    let text = (scanText || '').trim();

    if(!text) {
        return null;
    }

    try {
        let url = new URL(text);

        if(url.protocol == 'tractus:') {
            let entityType = (url.hostname || '').toLowerCase();

            if(entityType != 'attendee') {
                return null;
            }

            let attendeeCode = url.searchParams.get('c');
            let showCode = url.searchParams.get('s');

            if(!attendeeCode || !showCode) {
                return null;
            }

            return {
                attendeeCode,
                showCode
            };
        }

        if(url.protocol == 'https:'
            && url.hostname.toLowerCase() == 'event.tractus.ca'
            && url.pathname.toLowerCase() == '/login') {
            let attendeeCode = url.searchParams.get('a') || url.searchParams.get('c');
            let showCode = url.searchParams.get('s');

            if(!attendeeCode || !showCode) {
                return null;
            }

            return {
                attendeeCode,
                showCode
            };
        }
    } catch {
        return null;
    }

    return null;
}
